import React, { useState } from 'react';
import PACIAuthDemo from './PACIAuthDemo';

const PACIShowcase = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);

  const handleAuthSuccess = (user) => {
    setUserData(user);
    setIsAuthenticated(true);
  };

  const handleReset = () => {
    setIsAuthenticated(false);
    setUserData(null);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ 
            color: '#1e40af', 
            fontSize: '32px', 
            marginBottom: '16px',
            fontWeight: 'bold'
          }}>
            🇰🇼 PACI Integration Demo
          </h1>
          <p style={{ 
            color: '#6b7280', 
            fontSize: '18px',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Experience Kuwait's government-backed digital identity authentication 
            integrated into EnayaHub Healthcare Platform
          </p>
        </div>

        {/* Feature Highlights */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px',
          marginBottom: '40px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>🔐</div>
            <h3 style={{ color: '#1e40af', marginBottom: '8px' }}>Government Security</h3>
            <p style={{ color: '#6b7280', fontSize: '14px', margin: '0' }}>
              PACI-backed authentication with highest security standards
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>⚡</div>
            <h3 style={{ color: '#1e40af', marginBottom: '8px' }}>Fast Registration</h3>
            <p style={{ color: '#6b7280', fontSize: '14px', margin: '0' }}>
              Auto-populate patient data from official Civil ID records
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>🏥</div>
            <h3 style={{ color: '#1e40af', marginBottom: '8px' }}>Healthcare Ready</h3>
            <p style={{ color: '#6b7280', fontSize: '14px', margin: '0' }}>
              Compliant with Kuwait healthcare regulations and MOH requirements
            </p>
          </div>
        </div>

        {/* Main Demo Area */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          marginBottom: '40px'
        }}>
          {!isAuthenticated ? (
            <div>
              <h2 style={{ 
                textAlign: 'center', 
                color: '#1e40af', 
                marginBottom: '24px',
                fontSize: '24px'
              }}>
                Try PACI Authentication
              </h2>
              <PACIAuthDemo 
                onAuthSuccess={handleAuthSuccess}
              />
              
              {/* Demo Instructions */}
              <div style={{
                backgroundColor: '#fffbeb',
                border: '1px solid #f59e0b',
                borderRadius: '8px',
                padding: '16px',
                marginTop: '24px'
              }}>
                <h4 style={{ color: '#92400e', marginBottom: '8px', fontSize: '16px' }}>
                  📝 Demo Instructions:
                </h4>
                <ul style={{ color: '#92400e', fontSize: '14px', margin: '0', paddingLeft: '20px' }}>
                  <li>Enter any 12-digit number as Civil ID (e.g., 123456789012)</li>
                  <li>Choose QR Code scan (10s demo) or Push Notification (5s demo)</li>
                  <li>Watch the authentication flow simulation</li>
                  <li>See how user data is automatically populated</li>
                </ul>
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <h2 style={{ 
                color: '#059669', 
                marginBottom: '24px',
                fontSize: '24px'
              }}>
                🎉 Welcome to EnayaHub Healthcare!
              </h2>
              
              <div style={{
                backgroundColor: '#ecfdf5',
                border: '2px solid #10b981',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '24px',
                textAlign: 'left',
                maxWidth: '400px',
                margin: '0 auto 24px auto'
              }}>
                <h3 style={{ color: '#059669', marginBottom: '16px' }}>
                  Patient Profile Created
                </h3>
                <div style={{ fontSize: '16px', lineHeight: '1.6' }}>
                  <p style={{ margin: '0 0 8px 0' }}>
                    <strong>Arabic Name:</strong> {userData?.name}
                  </p>
                  <p style={{ margin: '0 0 8px 0' }}>
                    <strong>English Name:</strong> {userData?.nameEn}
                  </p>
                  <p style={{ margin: '0 0 8px 0' }}>
                    <strong>Civil ID:</strong> {userData?.civilId}
                  </p>
                  <p style={{ margin: '0 0 8px 0' }}>
                    <strong>Nationality:</strong> {userData?.nationality}
                  </p>
                  <p style={{ margin: '0' }}>
                    <strong>Verification:</strong> ✅ {userData?.verificationLevel} Level
                  </p>
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '12px',
                maxWidth: '400px',
                margin: '0 auto 24px auto'
              }}>
                <button style={{
                  padding: '12px 16px',
                  backgroundColor: '#0066CC',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}>
                  📅 Book Appointment
                </button>
                <button style={{
                  padding: '12px 16px',
                  backgroundColor: '#059669',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}>
                  💬 Consultation
                </button>
                <button style={{
                  padding: '12px 16px',
                  backgroundColor: '#7c3aed',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}>
                  📋 Medical Records
                </button>
              </div>

              <button
                onClick={handleReset}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#f3f4f6',
                  color: '#374151',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* Benefits Section */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ 
            textAlign: 'center', 
            color: '#1e40af', 
            marginBottom: '32px',
            fontSize: '24px'
          }}>
            Why PACI Integration Matters for Healthcare
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            <div>
              <h4 style={{ color: '#1e40af', marginBottom: '12px' }}>🏛️ Government Trust</h4>
              <p style={{ color: '#6b7280', fontSize: '14px', lineHeight: '1.6' }}>
                Official integration with Kuwait's Public Authority for Civil Information 
                provides the highest level of identity verification trusted by patients and healthcare providers.
              </p>
            </div>

            <div>
              <h4 style={{ color: '#1e40af', marginBottom: '12px' }}>⚕️ Healthcare Compliance</h4>
              <p style={{ color: '#6b7280', fontSize: '14px', lineHeight: '1.6' }}>
                Meets all Ministry of Health requirements for patient identification and 
                helps prevent healthcare fraud through verified digital identities.
              </p>
            </div>

            <div>
              <h4 style={{ color: '#1e40af', marginBottom: '12px' }}>🚀 Market Advantage</h4>
              <p style={{ color: '#6b7280', fontSize: '14px', lineHeight: '1.6' }}>
                First healthcare platform in Kuwait with official PACI integration, 
                providing significant competitive advantage and investor appeal.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '40px',
          color: '#6b7280',
          fontSize: '14px'
        }}>
          <p>
            This is a demonstration of the planned PACI integration. 
            Actual implementation requires official PACI developer access and government approval.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PACIShowcase;